import React from "react";
import svg_edit_blue from "src/img/chatBubbleActionIcons/edit_blue.svg";
import svg_cancel from "src/img/chatBubbleActionIcons/cancel_action.svg";
import { MessageContentDisplay } from "../../MessageContentDisplay";
import { InputActionTemplate } from ".";

export const EditContainer = ({ editMessageEvent, onSetEditMessageEventHandler, textInputRef, matrixClient }) => {
    const clearMessage = () => {
        textInputRef.current.value = "";
        onSetEditMessageEventHandler(null);
    };
    const content = editMessageEvent?.getContent();
    if (content?.msgtype === "m.text") {
        return (
            <InputActionTemplate 
                actionImageElement={<img src={svg_edit_blue} alt="Edit Preview" />}
                spanElement={<span>Editing Message</span>}
                previewMessage={<MessageContentDisplay content={content} matrixClient={matrixClient}/>}
                cancelImageElement={
                    <img
                        src={svg_cancel}
                        alt="Cancel Edit"
                        onClick={clearMessage}
                        style={{ cursor: "pointer" }}
                    />
                }
            />
        );
    }
};